import { createCookie } from '../Utility/CookieManager.js';

var has_init_jw_player = false;
var player;
var current_link_index = 0;

// START APP
function start_jw_player_library(){

    if(has_init_jw_player){
        return;
    }

    has_init_jw_player = true;

    var div_id = 'jw_player_video_anchor';

    // check should load right away
    if( jw_player_can_load(div_id) ){
        loadLibrary(div_id);
    // or else trigger lazy loading
    }else{
        lazy_init_jw_player(div_id);
    }
}

// check if jw player should load
function jw_player_can_load(selector){

    // on non-mobile load right away
    // UPDATE - now lazy on desktop too
    /*if( window.innerWidth >= 728 ){
        return true;
    }*/

    if( $('#'+selector) ) {
        // Find width of container, so you can calculate height based on 
        // assumed aspect ratio. Use half that height as offset when 
        // detecting if in viewport, so player doesn't load then instantly float.
        var offset = parseInt( ($('#'+selector).width() * 0.5625) / 2) + 1;

        if( $('#'+selector).inViewport(offset) ){
            return true;
        }
    }
    
    return false;
}

// listen for when the div becomes visible in viewport
function lazy_init_jw_player(selector){

    var timeout_id = null;

    var lazy_init_callback = function(){

        clearTimeout(timeout_id);
        timeout_id = setTimeout(function(){
            
            if( jw_player_can_load(selector) ){
                loadLibrary(selector);
                $(window).off("scroll rezise", lazy_init_callback);
                clearTimeout(timeout_id);
            }
        }, 100);
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

// UTILITY FUNCTIONS //
function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
}

function addClass(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!hasClass(el, className)) el.className += ' ' + className;
}

function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// MAIN FUNCTIONS

function loadLibrary(selector) {

    console.log("LOAD JW PLAYER LIBRARY");

    // Get URL of script tag
    // var scripts = document.querySelectorAll('script[src*="realclear_jw_widget_v2.js"]');

    // var myScript = scripts[scripts.length - 1];

    // Get id and auto|mute parameters from URL
    // var jw_id = getParameterByName("id", myScript.src);

    var anchor = document.getElementById(selector);

    if(!anchor){
        return;
    }

    var bottom = $('.RC-AD-MOBILE-BANNER').height();

    var jw_id = anchor.dataset.id;

    // Write container for player
    var jw_div = "realclear_jwplayer_"+jw_id;
    var html = '\
        <style>\
            #realclear_jwplayer_container {\
                position:relative;\
                cursor:pointer;\
            }\
            #realclear_jwplayer_container .realclear_jwplayer_overlay {\
                cursor:pointer;\
                position:absolute;\
                top:0;bottom:0;left:0;right:0;\
            }\
            #realclear_jwplayer_container.noclick .realclear_jwplayer_overlay {\
                pointer-events:none;\
            }\
            #realclear_jwplayer_container .pause_play {\
                position: absolute;\
                bottom: 0px;\
                left: 32px;\
                padding: 10px;\
                z-index: 10000;\
            }\
            #realclear_jwplayer_container .jw-wrapper {\
                bottom: '+ bottom +'px\
            }\
            #realclear_jwplayer_container .pause_play .inner{\
                cursor: pointer;\
                background: rgba(255,255,255, 0.5);\
                width: 25px;\
                height: 25px;\
                border-radius: 25px;\
                padding: 2px 0 0 2.4px;\
            }\
            #realclear_jwplayer_container .play .inner{\
                padding: 2px 0 0 4px;\
            }\
            #realclear_jwplayer_container .pause_play:hover .inner {\
                background: rgba(255,255,255, 1);\
            }\
            #realclear_jwplayer_container .audio {\
                position: absolute;\
                bottom: 0px;left: 0px;\
                padding: 10px;\
                z-index: 10000;\
            }\
            #realclear_jwplayer_container .audio .inner {\
                cursor: pointer;\
                background: rgba(255,255,255, 0.5);\
                width: 25px;\
                height: 25px;\
                border-radius: 25px;\
                padding: 2px 0 0 2px;\
            }\
            #realclear_jwplayer_container .audio:hover .inner {\
                background: rgba(255,255,255, 1);\
            }\
            #realclear_jwplayer_container .audio img:not(.active) {\
                display:none;\
            }\
            #realclear_jwplayer_container .close {\
                position: absolute;\
                top: -5px;right: -5px;\
                padding: 10px;\
                z-index: 10000;\
            }\
            #realclear_jwplayer_container .close .inner {\
                cursor: pointer;\
                background: rgba(255,255,255, 0.5);\
                width: 25px;\
                height: 25px;\
                border-radius: 25px;\
                padding: 5px 0 0 6px;\
            }\
            #realclear_jwplayer_container .close:hover .inner {\
                background: rgba(255,255,255, 1);\
            }\
            #realclear_jwplayer_parent_1 {\
                background:black;width:100%;\
            }\
            #realclear_jwplayer_parent_2 {\
                margin:0 auto;width:100%;clear:both;overflow:hidden;\
            }\
            #realclear_jwplayer_container .jw-wrapper {\
                bottom: 0px;\
            }\
            @media only screen and (max-width: 767px) {\
                #realclear_jwplayer_container .jw-flag-touch.jw-flag-floating .jw-wrapper {\
                    bottom: 78px !important;\
                }\
                .jw-flag-touch.jw-flag-floating .jw-wrapper {\
                    top: unset !important;\
                }\
            }\
        </style>\
        <div id="realclear_jwplayer_parent_1">\
            <div id="realclear_jwplayer_parent_2">\
                <div id="realclear_jwplayer_container">\
                    <div id="'+jw_div+'"></div>\
                </div>\
            </div>\
        </div>\
    ';

    if( $('#realclear_jwplayer_parent_1').length == 0 ){
        $(anchor).after(html);
    }

    // https://cdn.jwplayer.com/libraries/{key}.js
    var script = document.createElement('script');
    script.async = 1;
    script.src = "https://cdn.jwplayer.com/libraries/EAYoNgFe.js";
    script.onload = function() {
        setupPlayer(jw_div, jw_id);
    }
    document.head.appendChild(script);

}

function setupPlayer(jw_div, jw_id) {

    // [description_url], dynamic but doesn't seem to work.
    // So we'll populate this manually with the URI js detects.
    var jw_desc_url = "%5Bdescription_url%5D";
    jw_desc_url = encodeURI(window.location.href);

    window.jwplayer_hp_is_ad = false;

    // Get moat targetting so we can add it to cust_params
    var moat_cust_params = "";
    if(typeof window.moatPrebidApi != 'undefined') {
        var moat_targetting = window.moatPrebidApi.getMoatTargetingForPage();
        moat_cust_params = "%26"+encodeURIComponent(new URLSearchParams(moat_targetting).toString());
    }

    var cust_params = "";

    if( $('body').hasClass('home') || $('body').hasClass('polls')  ){ 
        cust_params = "&cust_params=site%3D__item-site__%26jwplayer_placement%3Dwidget_player"+moat_cust_params;
    }

    // Setup "chromeless" jwplayer
    player = jwplayer(jw_div);
    player.setup({
        playlist:           "https://cdn.jwplayer.com/v2/playlists/"+jw_id,
        // controls:           false,
        autostart:          true,
        floating:           true,
        mute:               true,
        nextUpDisplay:      false,
        repeat:             true,
        preload:            "auto",
        onclick:            "link",
        displaydescription: false,
        displaytitle:       false,
        //aspectratio:   "4:3",
        advertising: {
            client: "googima",
            //adscheduleid: "RV3tOnoJ", //test schedule setup on JWPlayer
            adscheduleid: "P3Te5eca", // Random 8-char alpha-num string
            schedule: [
                {
                    tag: "https://pubads.g.doubleclick.net/gampad/ads?sz=640x480|640x360|400x300|300x186&iu=/1004503/RC_video_preroll_640_by_480&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=%5Breferrer_url%5D&description_url="+jw_desc_url+"&correlator=%5Btimestamp%5D"+cust_params,
                    "offset": "pre",
                },
                {
                    tag: "https://pubads.g.doubleclick.net/gampad/ads?sz=640x480|640x360|400x300|300x186&iu=/1004503/RC_video_preroll_640_by_480&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=%5Breferrer_url%5D&description_url="+jw_desc_url+"&correlator=%5Btimestamp%5D"+cust_params,
                    "offset": 30, // 30 seconds
                },
                {
                    tag: "https://pubads.g.doubleclick.net/gampad/ads?sz=640x480|640x360|400x300|300x186&iu=/1004503/RC_video_preroll_640_by_480&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=%5Breferrer_url%5D&description_url="+jw_desc_url+"&correlator=%5Btimestamp%5D"+cust_params,
                    "offset": 60, // 60 seconds
                }
            ],
            "bids": {
                // Configure the ad partners
                "bidders": [{
                    "id": "257907",
                    "name": "Spotx"
                    //"pubid": "{PUBLISHER_ID}"
                }],
                "settings": {
                    "mediationLayerAdServer": "dfp",
                    "floorPriceCents": 200,
                    "buckets": [{
                        "increment": 10,
                        "min": 2,
                        "max": 100
                    }],
                    "consentManagement": {
                        "gdpr": {
                            "cmpApi": "iab",
                            "rules": {
                                "purpose": "basicAds",
                                "enforcePurpose": true,
                                "enforceVendor": true
                            },
                            "defaultGdprScope": true,
                            "timeout": 0 // GDPR timeout 0ms
                        },
                        "usp": {
                            "cmpApi": "iab",
                            "timeout": 0 // US Privacy timeout 0ms
                        }
                    }
                }
            }                
        },
        // floating: { // floating disabled so we can handle it manually
        //     mode: "never",
        // },
    });

    var pause, play;
    player.on('ready', function(data) {

        createCookie("jw_player_shown_new", "1", 2, true);

        var on_dst_close_notifier_data = {
            'ge_action' : 'Called Tag',
            'ge_category' : 'JW Player',
            'ge_label': 'Page: ' + $('body').attr('class'),
            'ge_index' : null,
            'ge_noninteraction' : true
        };
    
        send_notifier_event(on_dst_close_notifier_data);

        // Implement overlay, audio control and close btn

        var container = document.querySelector('#realclear_jwplayer_container .jw-wrapper');

        var overlay_el = document.createElement('div');
        addClass(overlay_el, "realclear_jwplayer_overlay");

        var audio_el = document.createElement('div');
        addClass(audio_el, "audio");
        audio_el.innerHTML = '<div class="inner"><img class="muted active" src="/asset/img/jw_player/muted.png" width="20" alt="Muted" /><img class="unmuted" src="/asset/img/jw_player/unmuted.png" width="20" alt="Unmuted" /></div>';

        // Enable mute button
        audio_el.onclick = function(event) {

            event.stopPropagation();
            if( player.getMute() ) {
                player.setMute(false);
                removeClass(
                    document.querySelector('#realclear_jwplayer_container .audio .muted'), 
                    "active"
                );
                addClass(
                    document.querySelector('#realclear_jwplayer_container .audio .unmuted'), 
                    "active"
                );
            } else {
                player.setMute(true);
                addClass(
                    document.querySelector('#realclear_jwplayer_container .audio .muted'), 
                    "active"
                );
                removeClass(
                    document.querySelector('#realclear_jwplayer_container .audio .unmuted'), 
                    "active"
                );
            }
        };

        var close_el = document.createElement('div');
        addClass(close_el, "close");
        close_el.innerHTML = '<div class="inner"><img src="/asset/img/jw_player/close.png" width="14" alt="Close" /></div>';

        // Enable close button
        close_el.onclick = function(event) {
            event.stopPropagation();
            player.remove();
            createCookie("jw_player_close_button_clicked", "1", 2, true);

            var on_dst_close_notifier_data = {
                'ge_action' : 'Close Player',
                'ge_category' : 'JW Player',
                'ge_label': 'Page: ' + $('body').attr('class'),
                'ge_index' : null,
                'ge_noninteraction' : false
            };
        
            send_notifier_event(on_dst_close_notifier_data);

            // remove the video header on latest polls page 
            if ($('body').attr('data-page') == 'latest_polls') {
                $('#distro_right_rail').css('display', 'none');
            }
        };

        pause = document.createElement('div');
        addClass(pause, "pause");
        addClass(pause, "pause_play");
        pause.innerHTML = '<div class="inner"><img src="/asset/img/jw_player/pause.png" width="20" alt="Pause" /></div>';

        pause.onclick = function() {
            var state = player.getState();
            console.log("STATE", state);

            player.pause();

            pause.style.display = 'none';
            play.style.display = 'block';

            var on_dst_close_notifier_data = {
                'ge_action' : 'Pause Player',
                'ge_category' : 'JW Player',
                'ge_label': 'Page: ' + $('body').attr('class'),
                'ge_index' : null,
                'ge_noninteraction' : false
            };
        
            send_notifier_event(on_dst_close_notifier_data);
        };

        play = document.createElement('div');
        addClass(play, "play");
        addClass(play, "pause_play");
        play.innerHTML = '<div class="inner"><img src="/asset/img/jw_player/play2.png" width="20" alt="Play" /></div>';
        play.style.display = 'none';

        play.onclick = function() {
            var state = player.getState();
            console.log("STATE", state);

            player.play();
            play.style.display = 'none';
            pause.style.display = 'block';

            var on_dst_close_notifier_data = {
                'ge_action' : 'Play Player',
                'ge_category' : 'JW Player',
                'ge_label': 'Page: ' + $('body').attr('class'),
                'ge_index' : null,
                'ge_noninteraction' : false
            };
        
            send_notifier_event(on_dst_close_notifier_data);
        };

        container.appendChild(overlay_el);
        container.appendChild(audio_el);
        container.appendChild(close_el);
        container.appendChild(pause);
        container.appendChild(play);

        // If inline video not 50% visible at least, float video.
        // var observer = new IntersectionObserver(function(entries, observer) {
        //     console.log("entries", entries);
        //     for(var i = 0; i < entries.length; i++) {
        //         console.log("entryloco", entries[i]);
        //         if( entries[i].intersectionRatio < 0.5 ) {
        //             // player.setConfig({
        //             //     aspectratio: "4:3",
        //             // });
        //             player.setFloating(true);
        //             player.floating(true);
        //             console.log("floating");
        //         } else {
        //             // player.setConfig({
        //             //     aspectratio: "16:9",
        //             // });
        //             player.setFloating(false);
        //             player.floating(false);
        //             console.log("not floating");
        //         }
        //     }

        // }, {
        //     root: null,
        //     rootMargin: '0px',
        //     threshold: 0.5
        // });
        // observer.observe(document.querySelector('#realclear_jwplayer_container'));
        // console.log("observer", observer);

        // Assign click function for overlay
        document.getElementById("realclear_jwplayer_container")
            .setAttribute(
                "onclick", 
                "window.jwplayer_hp_click(event);"
            );

    });

    // When playlist item changes, find video permalink URL and make clicks go to it.
    player.on('playlistItem', function(data){

        var link = get_link(data.item.description, 0);
        
        apply_link(link);
    });
    // When an ad starts, disable pointer events on overlay
    player.on('adBreakStart', function() {
        removeClass(document.getElementById("realclear_jwplayer_container"), "noclick");
        addClass(document.getElementById("realclear_jwplayer_container"), "noclick");
        window.jwplayer_hp_is_ad = true;
    });
    player.on('adStarted', function() {
        removeClass(document.getElementById("realclear_jwplayer_container"), "noclick");
        addClass(document.getElementById("realclear_jwplayer_container"), "noclick");
        window.jwplayer_hp_is_ad = true;
    });

    // When an ad ends, re-enabled pointer events on overlay
    player.on('adBreakEnd', function() {
        removeClass(document.getElementById("realclear_jwplayer_container"), "noclick");
        window.jwplayer_hp_is_ad = false;
    });
    player.on('adComplete', function() {
        removeClass(document.getElementById("realclear_jwplayer_container"), "noclick");
        window.jwplayer_hp_is_ad = false;
    });

    /**
     * @see https://developer.jwplayer.com/jwplayer/docs/jw8-javascript-api-reference#jwplayeronadblock
     */
    player.on('adblock', function(){

        var on_dst_close_notifier_data = {
            'ge_action' : 'Adblock Detected',
            'ge_category' : 'JW Player',
            'ge_label': 'Page: ' + $('body').attr('class'),
            'ge_index' : null,
            'ge_noninteraction' : true,
        };

        send_notifier_event(on_dst_close_notifier_data);
    });

    /**
     * @see https://developer.jwplayer.com/jwplayer/docs/jw8-javascript-api-reference#jwplayeronadclick
     */
    player.on('adClick', function(event){

        var state = player.getState();
        console.log("ADCLICK", "STATE", state, 'event', event);
        
        play.style.display = 'block';
        pause.style.display = 'none';

        var on_dst_close_notifier_data = {
            'ge_action' : 'Ad Clicked',
            'ge_category' : 'JW Player',
            'ge_label': 'Page: ' + $('body').attr('class'),
            'ge_index' : null,
            'ge_noninteraction' : false,
        };

        send_notifier_event(on_dst_close_notifier_data);
    });

    player.on('adPause', function(event){

        var state = player.getState();
        console.log("AD PAUSE", "STATE", state, 'event', event);
        
        play.style.display = 'block';
        pause.style.display = 'none';
    });

    player.on('adPlay', function(event){

        var state = player.getState();
        console.log("AD PLAY", "STATE", state, 'event', event);
        
        play.style.display = 'none';
        pause.style.display = 'block';
    });

    // Remove interval just in case it already exists
    if(typeof link_interval !== 'undefined') {
        window.clearInterval(link_interval);
    }

    // Find proper link depending on seconds passed,
    // and assuming link should change every 15 seconds.
    // Protections built in for if video repeats.
    var link_interval = window.setInterval(function() {

        var state = player.getState();
        if( state == 'paused' ){
            play.style.display = 'block';
            pause.style.display = 'none';
        }

        var playlists = player.getPlaylist();

        if(typeof playlists[0].description === 'undefined') {
            // Not available yet. Takes a few moments to load playlist.
            return; 
        }

        var playlist = playlists[player.getPlaylistIndex()];

        var links_count = get_links_count(playlist.description);

        var seconds_passed = player.getPosition();

        var link_index = Math.floor(seconds_passed / 15) % links_count;

        apply_link(get_link(playlist.description, link_index));

        //console.log("seconds_passed: "+seconds_passed);
        //console.log("links_count: "+links_count);
        //console.log("link_index: "+link_index);
        //console.log("link: "+get_link(playlist.description, link_index));

    }, 500); // Every 1/2 second
}

function get_filtered_links(link_str) {

    var links = link_str.split(/\r?\n/);

    // remove any empty elements in array, in case editors use 2 or more newlines
    // trim for any beginning or ending whitespace in same filter
    var filtered_links = links.filter(function(el) {
        var trimmed_str = el.trim();
        if(trimmed_str.length != 0) {
            return trimmed_str;
        }
    });

    return filtered_links;
}

function get_links_count(link_str) {

    var filtered_links = get_filtered_links(link_str);

    return filtered_links.length;
}

function get_link(link_str, index) {

    var filtered_links = get_filtered_links(link_str);
    current_link_index = index;

    return filtered_links[index];
}

function apply_link(url) {

    window.jwplayer_hp_click_url = url;
}

window.jwplayer_hp_click = function(event) {

    if( !hasClass(event.target, "realclear_jwplayer_overlay") ) {
        // This is probably catapultx
        return;

    } else if( !window.jwplayer_hp_is_ad ) {

        let url = window.jwplayer_hp_click_url;

        if(url != null){

            let utm_vars = `utm_campaign=JW_Promo_Player&utm_medium=Direct_${encodeURIComponent(document.body.classList.value)}&utm_source=${player.getPlaylistIndex()}-${current_link_index}`;

            if( !url.includes('?') ){
                url = url+'?'+utm_vars;
            }else{
                url = url+'&'+utm_vars;
            }

            console.log(url);
            window.open(url, '_blank');
        }

    } else {
        // Probably an ad
        return;
    }
};

export default start_jw_player_library;